import styled from "styled-components";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { LoadingBackDrop } from "../../../components/loader";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { theme } from "../../../helpers/theme";
import { StyledTable } from "../../../components/table/styled-table";
import { Services } from "../../../services/warehouses/services-get-by-id/types";
import { getAllWarehouseServicesGetById } from "../../../services/warehouses/services-get-by-id";
import ServicesEditForm from "../operator-warehouses-services-edit/components/form";
import { OperatorSubcontractorServicesEdit } from "../operator-warehouses-services-edit";
import { GoBackButton } from "../../../components/GoBackButton";

const OperatorWarehousesServices = () => {
  const { id } = useParams();
    const [subcontractorEdited, setSubcontractorEdited] = useState(
      {
        id: "",
        usluga: "",
        typ_uslugi: "",
        aktywny: false,
        wymaga_wyceny: false,
        info_dodatkowe: "",
      }
    );


  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 120,
      sortable: false,
      disableColumnMenu: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{
            backgroundColor: theme.colors.blue01_active,
          }}
          onClick={() => {
            handleOpen();
            setSubcontractorEdited({
              id: params.row.id,
              usluga: params.row.usluga,
              typ_uslugi: params.row.typ_uslugi,
              aktywny: params.row.czy_aktywna,
              wymaga_wyceny: params.row.czy_wymaga_wyceny,
              info_dodatkowe: params.row.info_dodatkowe,
            });
          }}
        >
          Edytuj
        </Button>
      ),
    },
    { 
    field: "usluga", 
    headerName: "Usługa", 
    width: 200 
    },
    { 
    field: "typ_uslugi", 
    headerName: "Typ", 
    width: 200 
    },
    { 
    field: "czy_aktywna", 
    headerName: "Aktywna", 
    width: 150 
    },
    { 
    field: "czy_wymaga_wyceny", 
    headerName: "Wymaga wyceny",
    width: 150 
    },
    { 
    field: "info_dodatkowe", 
    headerName: "Uwagi", 
    width: 300 
    },
  ];

  const [services, setServices] = useState<Services[]>([]);

  const body = {
    id_magazyn: String(id),
  };

  const GetAllWarehouseServicesGetById = useQuery(["Services"], () => getAllWarehouseServicesGetById(body), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,

    onSuccess(data) {
      setServices(data.data.payload.uslugi_magazynu);
    },
  });


  const getServiceFromEnum = (purpose: number) => {
    switch (purpose) {
      case 0:
        return "Składowanie";
      case 1:
        return "Cross-docking";
      case 2:
        return "Fullfilment";
      case 3:
        return "Etykietowanie";
      case 4:
        return "Pakowanie";
      case 5:
        return "Sortowanie";
      case 6:
        return "E-commerce";
      case 7:
        return "Wysyłka";
      case 8:
        return "Inne";
      case 9:
        return "Przyjęcie Towaru";
      case 10:
        return "Wydanie Towaru";
    }
  };

  const getTypeFromEnum = (type: number) => {
    switch (type) {
      case 0:
        return "Główna";
      case 1:
        return "Dodana";
      case 2:
        return "Dodatkowa";
    }
  };

  // const dateFormating = (date: Date) => {
  //   const dateSeconds = Date.parse(date.toString());
  //   const dateObject = new Date(dateSeconds);
  //   return dateObject.toLocaleDateString("pl-PL");
  // };

  const rows = services.map((r: Services) => ({
    id: r.id_uslugi_magazynow,
    usluga: getServiceFromEnum(r.usluga),
    typ_uslugi: getTypeFromEnum(r.typ_uslugi),
    czy_aktywna: (r.czy_aktywna ? "Tak" : "Nie"),
    czy_wymaga_wyceny: (r.czy_wymaga_wyceny ? "Tak" : "Nie"),
    info_dodatkowe: r.info_dodatkowe,
  }));

  //*Obsługa Modala-Start */
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    GetAllWarehouseServicesGetById.refetch();
  };
  //*Obsługa Modala-Stop */

  if (GetAllWarehouseServicesGetById.isLoading || GetAllWarehouseServicesGetById.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }

  const forms = [
    <ServicesEditForm
    id={subcontractorEdited.id}
    usluga={subcontractorEdited.usluga}
    typ_uslugi={subcontractorEdited.typ_uslugi}
    aktywny={subcontractorEdited.aktywny}
    wymaga_wyceny={subcontractorEdited.wymaga_wyceny}
    info_dodatkowe={subcontractorEdited.info_dodatkowe}
    handleClose={handleClose}
    />
  ]

  return (
    <>
      <ServicesContainer>
      <GoBackButton description={"Powrót"} goToUrl={-1} />
        <StyledTable
          // getRowId={(row) => row?.id}
          rows={rows}
          columns={columns}
          autoPageSize
        />
      </ServicesContainer>

      <OperatorSubcontractorServicesEdit
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        forms={forms}
      />
    </>
  );
};

export default OperatorWarehousesServices;

const ServicesContainer = styled.div`
  height: 80vh;

  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
